import types from '../types';

const initialState = {
  jwtAccessToken: '',
  amendmentList:{},
  auditLogList:false,
};

 const amendmentList = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_USER_JWT:
      return {
        ...state,
        jwtAccessToken: action.payload,
      };
      case types.RESET_CONFIGURATOR_STATE:
        return { 
           ...initialState ,
          };
      case types.SET_AMENDMENT_DATA:
        const { amendmentList} = action.payload;
        console.log("fghjk87tfgbnjuygfcngv1111",action)
        return {
          ...state,
          amendmentList,
        };
        case types.SET_AMENDMENT_RECORD:
        const { amendmentRecord} = action.payload;
        return {
          ...state,
          amendmentRecord,
        };
        case types.SET_AMENDMENT_VIEWWRKLSTACTVTY:
          const { amendmentviewWrkLstActvty} = action.payload;
        // return {
        // ...state,
        // amendmentviewWrkLstActvty,
        // };
       
    default:
      return state;
  }
};

export default amendmentList;
